"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function canonicalizeJSON(value) {
    if (Object.prototype.toString.call(value) === "[object Object]") {
        var sorted = {};
        var keys = Object.keys(value).sort();
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var keyValue = value[key];
            if (keyValue != null) {
                sorted[key] = canonicalizeJSON(keyValue);
            }
        }
        return sorted;
    }
    if (Array.isArray(value)) {
        return value.map(canonicalizeJSON);
    }
    return value === undefined ? null : value;
}
exports.canonicalizeJSON = canonicalizeJSON;
